module.exports = __webpack_public_path__ + "img/topic2-1.b13c6b9b.png";